export const config = {
  screens: {
    UnauthenticatedNavigator: {
      screens: {
        onboarding: {
          initialRouteName: "landing",
          path: "onboarding",
          screens: {
            landing: "landing",
            phone: "phone",
            code: "code",
            profile: "profile",
          },
        },
      },
    },
    Home: {
      initialRouteName: "events",

      screens: {
        trip: {
          screens: {
            TripDetail: "trips/:tripId",
          },
        },

        shop: "shop",
        events: "events",
        rides: {
          screens: {
            calendar: "calenar",
          },
        },
        club: {
          screens: {
            ClubScreen: "club",
            Partner: "partner/:partnerId",
            Perk: "partner/:partnerId/perk/:perkId",
          },
        },
        profileTab: {
          screens: {
            ProfileHome: "profile",
            EditProfile: "edit-profile",
          },
        },
      },
    },

    EventDetail: "events/:eventId",
    EventShare: "rides/:eventId",
    UserProfile: "members/:userId",
    ComingSoon: "coming-soon",
  },
};
